import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';

import type { AttendContactAbsenceJson } from '@/types/domain/attendContact/entities/attendContactAbsenceEntity';

import DialogTitle from '@/components/DialogTitle';
import DialogTransition from '@/components/DialogTransition';
import AbsenceInfo from '@/domain/attendContact/component/AbsenceInfo';

/**
 * プロパティ
 */
export type ConfirmInput = {
  /** データ */
  data: AttendContactAbsenceJson | undefined,
  /** 送る */
  onSend: (input: AttendContactAbsenceJson | undefined) => void,
}

const Confirm: React.FC<ConfirmInput> = ({ data, onSend }) => (
  <Dialog
    open={data !== undefined}
    onClose={() => onSend(undefined)}
    fullScreen
    TransitionComponent={DialogTransition}
  >
    <DialogTitle title="欠席連絡" />
    <DialogContent>
      <p>内容を確認し問題なければ、「送信」ボタンを押してください。</p>
      {data && <AbsenceInfo data={data} />}
    </DialogContent>
    <DialogActions>
      <Button variant="contained" onClick={() => onSend(data)} color="primary">
        送信
      </Button>
      <Button variant="contained" onClick={() => onSend(undefined)} color="primary">
        閉じる
      </Button>
    </DialogActions>
  </Dialog>
);

export default Confirm;
